'use strict';

require('../../base/accentColors.cjs');
var accentColors$1 = require('../../../../../../../../../../_virtual/accentColors.cjs');

var accentColors = accentColors$1.__exports;

var PILL_BASE_COLORS = /*#__PURE__*/ function(PILL_BASE_COLORS) {
    PILL_BASE_COLORS["success"] = "success";
    PILL_BASE_COLORS["system"] = "system";
    PILL_BASE_COLORS["highlight"] = "highlight";
    PILL_BASE_COLORS["danger"] = "danger";
    PILL_BASE_COLORS["warning"] = "warning";
    PILL_BASE_COLORS["info"] = "info";
    return PILL_BASE_COLORS;
}({});
({
    ...PILL_BASE_COLORS,
    ...accentColors.AVIARY_ACCENTS
});
//# sourceMappingURL=pill.cjs.map
